module.exports = __webpack_public_path__ + "static/img/warning-alert.6674af41.svg";